<template>
  <v-card style="border-radius: 30px;">
      <v-card-title>
        <v-row align="center" justify="center">
            <h3 class="primary--text font-weight-black text-uppercase">
              Sincroniza con el SAT
            </h3>
        </v-row>
      </v-card-title>
      <v-card-text class="mt-3" >
        <v-row class="text-center primary--text" align="center" justify="center">
          <h4>Este módulo te permite tener tu cuenta sincronizada con el SAT y de esta manera no tendrás que cargar tus facturas manualmente.</h4>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-stepper v-model="stepper" class="elevation-0">
          <v-stepper-step step="1" :complete="stepper > 1" class="pb-0 px-0 pt-0">
            Datos de Acceso
          </v-stepper-step>

          <v-stepper-content step="1" class="py-0 mx-auto text-center px-0">
            <v-img src="@/assets/images/sat.png" max-width="30%" class="mx-auto"/>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              class="mx-10">

              <v-text-field
                v-model='credentials.username'
                readonly
                label="R.F.C."/>

              <v-text-field
                v-model="credentials.password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required]"
                :type="showPassword ? 'text' : 'password'"
                label="Contraseña del SAT"
                hint="Contraseña"
                @click:append="showPassword = !showPassword"/>
            </v-form><br>

            <v-btn color="primary" rounded @click="$emit('onClose')" style="float: left">
              <h5 class="font-weight-bold">Cancelar</h5>
            </v-btn>

            <v-btn class="text-center" rounded color="primary" @click="validateCredentials()" style="float: right">
              <h5 class="font-weight-bold">Siguiente</h5>
            </v-btn>
          </v-stepper-content>

          <v-stepper-step step="2" :complete="stepper > 2" class="pb-0 px-0">
            Antigüedad de Facturas
          </v-stepper-step>

          <v-stepper-content step="2" class="text-center px-0">
            <h3 class="mx-10 primary--text">Descargaremos las facturas de los últimos <span class="font-weight-black">{{days}}</span> días.</h3>

            <v-form lazy-validation class="mx-16">
              <v-select
                v-model="days"
                :items="daysRange"
                :max-width="10"
                label="Días"/>
            </v-form>

            <v-btn color="primary" rounded @click="$emit('onClose')" style="float: left">
              <h5 class="font-weight-bold">Cancelar</h5>
            </v-btn>

            <v-btn class="text-center" rounded color="primary" style="float: right" @click="activateCredentials()">
              <h5 class="font-weight-bold">Siguiente</h5>
            </v-btn>
          </v-stepper-content>

          <v-stepper-step step="3" :complete="stepper >= 3" class="px-0">
            Terminar
          </v-stepper-step>

          <v-stepper-content step="3" class="pt-0 mx-auto text-center px-0">
            <h2 class="mx-10 primary--text font-weight-black">¡Conexión establecida con éxito!</h2><br>
            <h4 class="mx-10 primary--text">
               A partir ahora sincronizaremos con el SAT todos los dias para descargar tus facturas, las cuales estarán listas para vender.
            </h4>

            <v-img src="@/assets/images/success.gif" max-width="18%" class="mx-auto mt-4 mb-6"/>

            <h4 class="mb-6 primary--text">
               En un momento comenzaremos con la descarga.
            </h4>

            <h4 class="mb-6 primary--text">
              <input type="checkbox" class="special-checkbox" v-model="notifyDesyncSAT"/>
              <span class="ml-2 primary--text font-weight-black">¿Deseas que te notifiquemos cuando no podamos sincronizar con el SAT?</span>
            </h4>

            <v-btn color="#0420BF" dark rounded @click="satSync()">
                <h4 class="font-weight-black">Terminar</h4>
            </v-btn>
          </v-stepper-content>
        </v-stepper>
      </v-card-text>
    </v-card>
</template>

<script>
import SATService from '@/services/SATService'
import ClientUserService from '@/services/ClientUserService'
import * as Sentry from '@sentry/vue'

export default {
  name: 'ConnectSat',
  data () {
    return {
      user: this.$store.getters.user,
      credentials: {
        username: this.$store.getters.user.client.rfc,
        password: '',
        userId: this.$store.getters.user.userId,
        clientId: this.$store.getters.user.client.clientId
      },
      notifyDesyncSAT: true,
      days: 90,
      showPassword: false,
      valid: false,
      rules: {
        required: value => !!value || 'Requerido'
      },
      stepper: 1,
      daysRange: [30, 60, 90, 120]
    }
  },
  methods: {
    async validateCredentials () {
      await this.$refs.form.validate()
      if (this.valid) {
        const loader = this.$loading.show()
        try {
          await SATService.validateCredentials(this.credentials)
          loader.hide()
          this.stepper = 2
        } catch (error) {
          loader.hide()
          this.$swal({
            title: '¡Error!',
            html: 'No pudimos establecer la conexión, verifica tu contraseña',
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#1374F2',
            showCloseButton: true
          })
        }
      }
    },
    async activateCredentials () {
      const loader = this.$loading.show()
      try {
        await SATService.updateCredentials({ clientId: this.credentials.clientId, syncActive: true, days: this.days })
        this.user.SATsyncActive = true
        this.user.SATlastSync = null
        this.user.SATdownloading = true
        await this.$store.dispatch('setUser', { user: this.user, isLoggedIn: true })
        loader.hide()
        this.$store.dispatch('SatSync', { clientId: this.credentials.clientId })
        this.stepper = 3
      } catch (error) {
        console.error('error on activateCredentials', error)
        Sentry.captureException(error)
        loader.hide()
        this.$swal({
          title: '¡Error!',
          html: 'Tenemos problemas internos, por favor intenta más tarde',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Ok',
          confirmButtonColor: '#1374F2',
          showCloseButton: true
        })
      }
    },
    async satSync () {
      const loader = this.$loading.show()
      try {
        const user = this.$store.getters.user
        user.notifications.desyncSAT = this.notifyDesyncSAT
        await ClientUserService.update(user)
        await this.$store.dispatch('setUser', { user: user, isLoggedIn: true })
        loader.hide()
        this.$emit('onClose')
      } catch (error) {
        console.error('error on satSync', error)
        Sentry.captureException(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
